import 'css-chunk:../../frontend/phi3d/src/js/components/Modals/WelcomeDemo.module.scss';export default {
  "actions": "_actions_18xon_1",
  "footer": "_footer_18xon_5"
};